import { useEffect, useMemo, useState } from "react";
import { getInviteMemberPayload } from "../../../../helpers/User";
import useAvailableSeats from "../../../../hooks/useAvailableSeats";

const useInviteContactPopup = ({ popupData, closePopup }) => {
  const onFinish = popupData?.onFinish;
  const userInfo = popupData?.userInfo;
  const roles = popupData?.roles;
  const states = popupData?.states;
  const directReportOptions = popupData?.directReportOptions;
  const [isEmployee, setIsEmployee] = useState(false);
  const [userRole, setUserRole] = useState();
  const [employeeType, setEmployeeType] = useState();
  const [stateOfEmployment, setStateOfEmployment] = useState();
  const [employeeId, setEmployeeId] = useState();
  const [selectedDirectReport, setSelectedDirectReport] = useState([]);
  const [, setDirectReport] = useState([]);
  const [hireDate, setHireDate] = useState();
  const { availableSeats } = useAvailableSeats();

  useEffect(() => {
    if (selectedDirectReport?.length > 0) {
      const newDirectReport = { user: [], role: [] };
      selectedDirectReport?.forEach((dr) => {
        if (dr?.value?.startsWith("User/"))
          newDirectReport.user.push(dr?.value);
        else if (dr?.value?.startsWith("Role/"))
          newDirectReport.role.push(dr?.value);
      });

      setDirectReport(newDirectReport);
    }
  }, [selectedDirectReport]);

  /**
   * Memoized Values
   */
  const emails = useMemo(() => {
    return userInfo?.contactPoint?.reduce((list, item) => {
      if (item?.system === "Email") {
        list.push({ label: item?.value, value: item?.value });
      }
      return list;
    }, []);
  }, [userInfo?.contactPoint]);

  const numbers = useMemo(() => {
    return userInfo?.contactPoint?.reduce((list, item) => {
      if (item?.system === "Phone") {
        list.push({ label: item?.value, value: item?.value });
      }
      return list;
    }, []);
  }, [userInfo?.contactPoint]);

  const newUser = useMemo(() => {
    if (userInfo?.new) {
      const email =
        userInfo?.contactPoint?.find((item) => item?.system === "Email")
          ?.value ?? "No Email";

      const number =
        userInfo?.contactPoint?.find((item) => item?.system === "Phone")
          ?.display ?? "No Entry";
      return { email, number };
    }

    return null;
  }, [userInfo?.contactPoint, userInfo?.new]);

  const invalidForm = useMemo(() => {
    const handleEmployee = isEmployee ? employeeId?.length > 0 : true;
    return !(
      !!selectedDirectReport?.value?.length &&
      !!userRole?.value?.length &&
      handleEmployee
    );
  }, [
    employeeId?.length,
    isEmployee,
    selectedDirectReport?.value?.length,
    userRole?.value?.length,
  ]);

  const sendInvite = () => {
    const payload = getInviteMemberPayload(userInfo, {
      isEmployee,
      role: userRole,
      employeeType,
      stateOfEmployment,
      directReport: selectedDirectReport,
      employeeId,
      hireDate,
    });
    onFinish(payload);
    closePopup();
  };

  return {
    roles,
    states,
    directReportOptions,
    invalidForm,
    sendInvite,
    newUser,
    emails,
    numbers,
    userRole,
    setUserRole,
    isEmployee,
    setIsEmployee,
    stateOfEmployment,
    setStateOfEmployment,
    employeeId,
    setEmployeeId,
    selectedDirectReport,
    setSelectedDirectReport,
    employeeType,
    setEmployeeType,
    hireDate,
    setHireDate,
    availableSeats,
  };
};

export default useInviteContactPopup;
